export default __webpack_public_path__ + "static/media/sunset.1b86d34fb16dcb4bfe7ef4ad02a63baa.svg";